import React, { memo } from 'react';

const TwitterIcon = (props) => (
    <svg
        width="26"
        height="22"
        viewBox="0 0 26 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.27423 21.506C17.603 21.506 22.7046 13.4716 22.7046 6.50443C22.7046 6.27625 22.7001 6.04913 22.6902 5.82294C23.6829 5.07624 24.5396 4.15172 25.2201 3.0927C24.3114 3.5127 23.3335 3.79539 22.3076 3.92284C23.3547 3.27012 24.1586 2.2375 24.5379 1.00662C23.5423 1.62059 22.4531 2.05341 21.3173 2.28642C20.3918 1.26158 19.0742 0.620605 17.6152 0.620605C14.8144 0.620605 12.5432 2.9818 12.5432 5.89233C12.5432 6.30612 12.5877 6.70848 12.6748 7.09454C8.45953 6.87405 4.72177 4.77601 2.22026 1.58582C1.76972 2.39045 1.53274 3.30492 1.53352 4.23586C1.53352 6.0651 2.42887 7.67991 3.79049 8.62466C2.98508 8.59908 2.19735 8.37293 1.49353 7.9652C1.49278 7.98734 1.49278 8.0089 1.49278 8.03256C1.49278 10.5859 3.24097 12.7179 5.56165 13.2009C5.1258 13.3243 4.67604 13.3867 4.2243 13.3865C3.89807 13.3865 3.58012 13.3531 3.27112 13.2914C3.91681 15.3863 5.78911 16.9108 8.00894 16.9534C6.27306 18.3678 4.08638 19.2103 1.70978 19.2103C1.30549 19.2106 0.90153 19.1863 0.5 19.1372C2.74461 20.6329 5.40986 21.5056 8.27448 21.5056"
            fill="currentColor" />
    </svg>

);

export default memo(TwitterIcon);
